// import { useEffect, useMemo, useState } from 'react';
import { Link } from '@tanstack/react-router';
// import { BookAlert, ChevronDown } from 'lucide-react';
import { BookAlert } from 'lucide-react';

import { Container } from '@/components/custom/container';
// import { Input } from '@/components/ui/input';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';
import { useStore } from '@/stores';

// import { IconMenu } from './icon-list';
import { IconSide } from './icon-list';

const HARDCODED_ACCESS = [
  {
    group: 'Reports',
    order: 2,
    role_access: [
      {
        name: 'Transaction',
        route: '/transaction',
        action: ['TRANSACTION_DOWNLOAD_REPORT', 'TRANSACTION_READ_TABLE'],
        order: 2,
      },
      {
        name: 'Virtual Account',
        route: '/virtual-account',
        action: ['VIRTUAL_ACCOUNT_READ_TABLE'],
        order: 3,
      },
      // {
      //   name: 'Credit Card',
      //   route: '/credit-card',
      //   action: null as string[] | null,
      //   order: 9,
      // },
      {
        name: 'Ewallet',
        route: '/ewallet',
        action: ['EWALLET_READ_TABLE'],
        order: 9,
      },
      {
        name: 'Debit Card',
        route: '/direct-debit',
        action: ['DIRECT_DEBIT_READ_TABLE'],
        order: 10,
      },
      {
        name: 'Portal Download',
        route: '/download-portal',
        action: [
          'TRANSACTION_REPORT_DOWNLOAD',
          'TRANSACTION_REPORT_DETAIL',
          'TRANSACTION_REPORT_LIST',
        ],
        order: 12,
      },
    ],
  },
  {
    group: 'Invoices',
    order: 3,
    role_access: [
      {
        name: 'Payment Link',
        route: '/payment-link',
        action: ['PAYMENT_LINK_CREATE', 'PAYMENT_LINK_READ_TABLE'],
        order: 1,
      },
    ],
  },
];

const SidebarItems = () => {
  const { toggleSidebar } = useDashboardContext();
  const userProfile = useStore((state) => state.profile);
  // const merchantAccess = useStore((state) => state.merchantAccess);
  // const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});
  // const [searchTerm, setSearchTerm] = useState('');

  // const homeGroupKey = useMemo(() => {
  //   // const access = merchantAccess?.access || [];
  //   const access = HARDCODED_ACCESS;
  //
  //   const homeIndex = access.findIndex((item) => item.group?.toLowerCase() === 'home');
  //   if (homeIndex < 0) return null;
  //   const homeGroup = access[homeIndex];
  //   return homeGroup.group || `group-${homeIndex}`;
  //   // }, [merchantAccess?.access]);
  // }, []);

  // useEffect(() => {
  //   if (homeGroupKey && Object.keys(openGroups).length === 0) {
  //     setOpenGroups({ [homeGroupKey]: true });
  //   }
  // }, [homeGroupKey]);

  // const toggleGroup = (groupKey: string) => {
  //   setOpenGroups((prev) => ({
  //     ...prev,
  //     [groupKey]: !prev[groupKey],
  //   }));
  // };

  // const normalizedSearch = searchTerm.trim().toLowerCase();

  // const toTestId = (value: string) =>
  //   value
  //     .toLowerCase()
  //     .replace(/[^a-z0-9]+/g, '-')
  //     .replace(/^-+|-+$/g, '');

  // const filteredAccess = useMemo(() => {
  //   // const access = merchantAccess?.access || [];
  //   const access = HARDCODED_ACCESS;
  //
  //   if (!normalizedSearch) return access;
  //
  //   return access
  //     .map((group) => {
  //       if (!group.group) return null;
  //       const groupMatch = group.group.toLowerCase().includes(normalizedSearch);
  //       const roleAccess = groupMatch
  //         ? group.role_access
  //         : group.role_access.filter((role) => role.name?.toLowerCase().includes(normalizedSearch));
  //
  //       if (roleAccess.length === 0) return null;
  //
  //       return {
  //         ...group,
  //         role_access: roleAccess,
  //       };
  //     })
  //     .filter((group): group is NonNullable<typeof group> => Boolean(group));
  //   // }, [merchantAccess?.access, normalizedSearch]);
  // }, [normalizedSearch]);

  const filteredAccess = HARDCODED_ACCESS.map((group) => ({
    ...group,
    role_access: group.role_access.filter((sidebar) => {
      if (sidebar.name !== 'Payment Link') return true;

      return userProfile?.role !== 'superadmin';
    }),
  })).filter((group) => group.role_access.length > 0);

  return (
    <Container direction="column" className="overflow-y-auto">
      {filteredAccess.map((item, idx) => {
        if (!item.group) return null;
        return (
          <div key={idx} className="text-gray-500">
            <div className="mt-2 px-3 py-1 text-xs leading-6 font-bold text-gray-600 first:mt-3">
              {item.group.toLocaleUpperCase()}
            </div>
            {item.role_access.map((sidebar, sidebarIdx) => {
              const IconComponent =
                IconSide.find((iconItems) => iconItems.name === sidebar.name)?.icon || BookAlert;

              if (sidebar.name === 'Mode') return null;
              return (
                <Link
                  to={sidebar.route}
                  key={sidebarIdx}
                  activeProps={{
                    className: 'text-white bg-brand-blue hover:bg-brand-blue hover:text-white',
                  }}
                  onClick={toggleSidebar}
                  className="hover:text-brand-blue flex items-center gap-4 rounded-lg px-2.5 py-3 text-sm leading-5 font-normal whitespace-nowrap hover:bg-blue-50"
                >
                  <IconComponent size={20} />
                  <div>{sidebar.name}</div>
                </Link>
              );
            })}
          </div>
        );
      })}
    </Container>
  );

  // return (
  //   <Container
  //     direction="column"
  //     className="overflow-y-auto px-4 pb-2 sm:px-0 sm:pb-0"
  //     data-testid="sidebar-items"
  //   >
  //     <div className="sticky top-0 z-10 bg-white px-1.5 pt-1 pb-2">
  //       <Input
  //         value={searchTerm}
  //         onChange={(e) => setSearchTerm(e.target.value)}
  //         placeholder="Search menu"
  //         className="h-9 text-sm"
  //         data-testid="sidebar-search-input"
  //       />
  //     </div>
  //     {filteredAccess.map((item, idx) => {
  //       if (!item.group) return null;
  //       const groupKey = item.group || `group-${idx}`;
  //       const isOpen = normalizedSearch ? true : (openGroups[groupKey] ?? false);
  //       const IconComponent =
  //         IconMenu.find((iconItems) => iconItems.name === item.group)?.icon || BookAlert;
  //
  //       return (
  //         <div
  //           key={idx}
  //           className="text-gray-500 sm:rounded-none sm:border-0"
  //           data-testid={`sidebar-group-${toTestId(item.group)}`}
  //         >
  //           <button
  //             type="button"
  //             onClick={() => toggleGroup(groupKey)}
  //             className="flex min-h-10 w-full items-center justify-between rounded-md px-1.5 py-2 text-left text-sm leading-6 font-semibold text-gray-600 sm:rounded-none sm:py-3"
  //             data-testid={`sidebar-group-toggle-${toTestId(item.group)}`}
  //           >
  //             <div className="flex flex-row items-center gap-x-2">
  //               <IconComponent size={20} className="shrink-0" />
  //               <span className="pr-2 break-words">{item.group.toLocaleUpperCase()}</span>
  //             </div>
  //             <ChevronDown
  //               size={16}
  //               className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
  //             />
  //           </button>
  //           {isOpen &&
  //             item.role_access.map((sidebar, sidebarIdx) => {
  //               if (sidebar.name === 'Mode') return null;
  //               return (
  //                 <Link
  //                   to={sidebar.route}
  //                   key={sidebarIdx}
  //                   activeProps={{
  //                     className: 'text-white bg-brand-blue hover:bg-brand-blue hover:text-white',
  //                   }}
  //                   onClick={toggleSidebar}
  //                   className="hover:text-brand-blue flex min-h-10 items-center gap-3 rounded-md py-2 pr-2.5 pl-8 text-sm leading-5 font-normal break-words hover:bg-blue-50 sm:gap-4 sm:whitespace-nowrap"
  //                   data-testid={`sidebar-item-${toTestId(sidebar.name || `item-${sidebarIdx}`)}`}
  //                 >
  //                   <div className="leading-snug">{sidebar.name}</div>
  //                 </Link>
  //               );
  //             })}
  //         </div>
  //       );
  //     })}
  //   </Container>
  // );
};

export default SidebarItems;
